import axios from 'axios';
import AppConfig from "../../../../AppConfig";

let URL = AppConfig.HOST_API()+'bilety/platnosci/';

export default {

    getEplatnosci() {
        return axios({
            method: 'get',
            url: URL + '?page=0&size=9999',
        });
    },

    getEPlatnosciPageable(page,size){
        return axios({
            method: 'get',
            url: URL + '?page='+page+'&size='+size,
        });
    }

}


// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/eplatnosci/EplatnosciService.js